var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[(_vm.errorMessage)?_c('div',[_c('h2',[_vm._v(_vm._s(_vm.errorMessage))])]):_c('div',{attrs:{"id":"stytch-sdk"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }